document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('#advantagesSection .nav-link');
  const tabContent = document.querySelector('#advantagesSection .tab-content');
  const tabPanes = document.querySelectorAll('#advantagesSection .tab-pane');

  const changeActiveTab = (index) => {
      tabs.forEach((tab, i) => {
          if (i === index) {
              tab.classList.add('active');
          } else {
              tab.classList.remove('active');
          }
      });
  };

  const handleTabClick = (e) => {
      e.preventDefault();
      const tabIndex = [...tabs].indexOf(e.currentTarget);
      tabContent.scrollLeft = tabPanes[tabIndex].offsetLeft - 20;
  };

  const checkVisibleTab = () => {
      let closestTabIndex = 0;
      let minDistance = Number.MAX_VALUE;

      tabPanes.forEach((pane, index) => {
          const distance = Math.abs(pane.offsetLeft - tabContent.scrollLeft);
          if (distance < minDistance) {
              closestTabIndex = index;
              minDistance = distance;
          }
      });

      changeActiveTab(closestTabIndex);
  };

  const init = () => {
    if (window.innerWidth < 992) {
      tabs.forEach(tab => {
        tab.addEventListener('click', handleTabClick);
    });
  
        if (tabContent) {
            tabContent.addEventListener('scroll', checkVisibleTab);
        }
    }
  }

  init();

  window.addEventListener('resize', () => {
    init();
  })
});
